import { render, staticRenderFns } from "./couponSheet.vue?vue&type=template&id=22897a9f&scoped=true&lang=html&"
import script from "./couponSheet.vue?vue&type=script&lang=js&"
export * from "./couponSheet.vue?vue&type=script&lang=js&"
import style0 from "./couponSheet.vue?vue&type=style&index=0&id=22897a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22897a9f",
  null
  
)

export default component.exports